/**
 * @Author:
 * @Description:
 * @DateTime: Created in 17:28 2020/10/16
 */

 import * as Vue from 'vue-tsx-support';
 import { Component, Prop, Watch } from 'vue-property-decorator';
 import 'vue-tsx-support/enable-check';
 import { createBEM } from 'src/util/bem';
 import './overproofStation.less';
 import IndexPageApi, { IndexPageDOI } from '../api/IndexPage';
 import TextMarquee from 'src/components/textMarquee/textMarquee';
 let bem = createBEM('overproof-station');
 
 @Component
 export default class OverproofStation extends Vue.Component<{ type: number; time: number }> {
     @Prop({
         type: Number,
     })
     type!: number;
 
     @Prop({
         type: Number,
         default: 15000,
     })
     time!: number;
 
     totalCount = 0;
     currentPage = 1;
     rows: IndexPageDOI.OverproofStationI[] = [];
     itv;
 
     @Watch('type')
     typeChange() {
         this.currentPage = 1;
         this.search();
     }
 
     scale = 1;
 
     async search() {
         let { code, data } = await IndexPageApi.searchOverproofStation(this.type, this.currentPage, 5);
         if (code === 0) {
             this.rows = data.data_info;
             this.totalCount = data.page_count;
         }
     }
     mounted() {
         this.search();
         let dom = this.$refs.content as any;
         let width = dom.offsetWidth;
         let height = dom.offsetHeight;
         this.scale = Math.min(width/415, height/280);
     }
     beforeDestroy() {
         clearInterval(this.itv);
     }
     renderItem(h, i: IndexPageDOI.OverproofStationI, img, position: any = { x: 0, y: 0 }) {
         return (
             <div class={bem('item')}>
                 <div class={bem('component-name')}>{i.component_name}</div>
                 <div class={bem('value')}>{i.value}</div>
                 <img class={bem('img')} src={img} />
                 <div class={bem('device-name')}>
                     <TextMarquee>{i.device_name}</TextMarquee>
                 </div>
             </div>
         );
     }
     render(h) {
         return (
             <div class={bem()}>
                 <div class={bem('title')}>超标站点</div>
                 <div ref="content" class={bem('content')} style={{ transform: 'tran' }}>
                     <div class={bem('container')} style={{transform:`translate(-50%, -50%) scale(${this.scale})`}}>
                         {this.rows[0] && this.renderItem(h, this.rows[0], require('../../../assets/images/01.png'), { x: '0%', y: '30px' })}
                         {this.rows[1] && this.renderItem(h, this.rows[1], require('../../../assets/images/02.png'), { x: '50%', y: '0%' })}
                         {this.rows[2] && this.renderItem(h, this.rows[2], require('../../../assets/images/03.png'), { x: '0%', y: '50%' })}
                         {this.rows[3] && this.renderItem(h, this.rows[3], require('../../../assets/images/04.png'), { x: '30%', y: '45%' })}
                         {this.rows[4] && this.renderItem(h, this.rows[4], require('../../../assets/images/05.png'), { x: '60%', y: '30%' })}
                     </div>
                     {/* <div class={bem('head')}>
                         <div>序号</div>
                         <div>站点名称</div>
                         <div>组分</div>
                         <div>浓度</div>
                     </div>
                     {this.rows.map((i, index) => {
                         return (
                             <div class={bem('row')}>
                                 <div>NO.{index + this.currentPage * 5 - 4}</div>
                                 <TextMarquee>{i.device_name}</TextMarquee>
                                 <div>{i.component_name}</div>
                                 <div>{i.value}</div>
                             </div>
                         );
                     })} */}
                 </div>
             </div>
         );
     }
 }
 